import { useEffect } from 'react';
import { reportWebVitals } from '@/lib/webVitals';

/**
 * Hook to track Core Web Vitals on a specific page
 *
 * @example
 * useWebVitals((metric) => {
 *   analytics.send(metric);
 * });
 */
export const useWebVitals = () => {
  useEffect(() => {
    // Report to console in dev, or analytics in prod
    reportWebVitals((_metric) => {
      // Logic to send to analytics endpoint could go here
      // For now, the reportWebVitals function handles console logging in dev
      // and we could extend this to push to a data layer

      // Example:
      // if (window.dataLayer) {
      //   window.dataLayer.push({
      //     event: 'web-vital',
      //     event_category: 'Web Vitals',
      //     event_action: metric.name,
      //     event_value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      //     event_label: metric.id,
      //   });
      // }
    });
  }, []);
};
